module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/13mill-inactive-a005c58d1c542cc09be90517dc6ee1b2.png";